import "@/App.css";
import { useState, useCallback, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import HomePage from "@/pages/HomePage";
import CorporatePage from "@/pages/CorporatePage";
import ServicesPage from "@/pages/ServicesPage";
import FleetPage from "@/pages/FleetPage";
import SafetyPage from "@/pages/SafetyPage";
import ReferencesPage from "@/pages/ReferencesPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";
import KVKKPage from "@/pages/KVKKPage";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import WhatsAppButton from "@/components/layout/WhatsAppButton";
import CookieConsent from "@/components/layout/CookieConsent";
import Preloader from "@/components/layout/Preloader";
import ScrollProgress from "@/components/layout/ScrollProgress";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); }, [pathname]);
  return null;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<HomePage />} />
    <Route path="/kurumsal" element={<CorporatePage />} />
    <Route path="/hizmetler" element={<ServicesPage />} />
    <Route path="/hizmetler/:serviceId" element={<ServicesPage />} />
    <Route path="/filo-teknoloji" element={<FleetPage />} />
    <Route path="/guvenlik-kalite" element={<SafetyPage />} />
    <Route path="/referanslar" element={<ReferencesPage />} />
    <Route path="/iletisim" element={<ContactPage />} />
    <Route path="/kvkk" element={<KVKKPage />} />
    <Route path="/gizlilik" element={<KVKKPage />} />
    <Route path="*" element={<NotFoundPage />} />
  </Routes>
);

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const handlePreloaderComplete = useCallback(() => {
    setIsLoading(false);
  }, []);

  return (
    <div className="App">
      {isLoading && <Preloader onComplete={handlePreloaderComplete} />}
      <BrowserRouter>
        <ScrollToTop />
        <ScrollProgress />
        <Header />
        <main>
          <AppRoutes />
        </main>
        <Footer />
        <WhatsAppButton />
        <CookieConsent />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
